module.exports = __webpack_public_path__ + "static/tap-the-email-fa23691e6dcbdcc0f1a8ee6c57ed1401.png";